import React, { ReactElement } from 'react'
import Locative from './Locative'
import LocativeHeberge from './LocativeHeberge'
import LocativeAssociation from './LocativeAssociation'
import { ILogementBuilderProps } from '../../interfaces/Logement'
import AddressNotChangeHostDocument from './AddressNotChangeHostDocument'

function LogementBuilder({
  type,
  ...rest
}: ILogementBuilderProps): ReactElement {
  switch (type) {
    case '1':
      return <Locative {...rest} />
    case '2':
      return <LocativeHeberge {...rest} />
    case '3':
      return <LocativeAssociation {...rest} />
    case '4':
      return <AddressNotChangeHostDocument {...rest} />
    default:
      return <></>
  }
}

export default LogementBuilder
